import { useIntl } from 'react-intl';

export function useIndeedEndDateTypeOptions() {
  const intl = useIntl();

  return [
    {
      id: 'fixed',
      value: 'fixed',
      label: intl.formatMessage({
        defaultMessage: 'Fixed end date',
        description:
          'Indeed schedule mode name: the campaign has a hard last day',
      }),
      description: intl.formatMessage({
        defaultMessage:
          'If set, Indeed optimizes to spend the budget efficiently by this date and also ensures that the campaign doesn’t spend beyond the specified date even if there is budget remaining.',
        description:
          'Explains that spend stops completely on the chosen date even if money remains',
      }),
    },
    {
      id: 'target',
      value: 'target',
      label: intl.formatMessage({
        defaultMessage: 'Target end date',
        description:
          'Indeed schedule mode name: preferred end day but not a hard cap',
      }),
      description: intl.formatMessage({
        defaultMessage:
          'If set, Indeed optimizes to spend the budget efficiently by this date, but the campaign may spend past this date if the campaign still has budget remaining.',
        description:
          'Explains that this date paces spend but the campaign can run past it if budget allows',
      }),
    },
  ];
}
